<template>
  <MarketplaceCard
    v-if="integrations"
    v-model="integrations.pulse_m.enabled"
    :logo-path="imageUrl"
    logo-alt="PulseM"
    description="The #1 online review management platform for home services. Easily connect with industry-leading field management software."
    learn-more-link="https://pulsem.me/"
    cy-selector="marketplacePulseM"
  >
    <template #configure>
      <div>
        <div class="link" @click="toggleModal">Set Up Information</div>
      </div>
    </template>
    <template #modal>
      <div>
        <Modal
          v-if="modalOpen"
          title="Set Up Information - pulseM"
          class-name="pulse-m-config-modal"
          @submit="handleSave"
          @hide-modal="toggleModal"
        >
          <div class="d-flex flex-column">
            <TextField
              v-model="integrations.pulse_m.api_key"
              class="full-width"
              label="API Key"
              name="api_key"
              placeholder="API Key"
              :validation-errors="v$.$errors"
            />
          </div>
        </Modal>
      </div>
    </template>
  </MarketplaceCard>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Modal from "@/components/Modal.vue";
import TextField from "@/components/TextField.vue";
import PulseMLogo from "@/images/pulsem_logo.png";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import MarketplaceCard from "./MarketplaceCard.vue";

export default {
  components: {
    MarketplaceCard,
    Modal,
    TextField
  },
  data() {
    return {
      modalOpen: false,
      initialEnabledValueLoaded: false
    };
  },
  computed: {
    ...mapState(["integrations"]),
    imageUrl: {
      get() {
        return PulseMLogo;
      },
    },
  },
  watch: {
    "integrations.pulse_m.enabled": function (newValue, oldValue) {
      if (!this.initialEnabledValueLoaded) {
        this.initialEnabledValueLoaded = true;
        return;
      }

      if (newValue !== oldValue) {
        this.updateEnabled();
      }
    }
  },
  mounted() {
    this.fetchIntegrations();
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      integrations: {
        pulse_m: {
          api_key: { required, $autoDirty: true }
        }
      }
    };
  },
  methods: {
    ...mapActions(["fetchIntegrations", "updateIntegrations"]),
    handleSave() {
      this.v$.$validate().then((valid) => {
        if (valid) {
          this.updateIntegrations({
            integrations: this.integrations
          }).then(() => {
            window.notify.success("pulseM settings saved!");
            this.toggleModal();
          });
        }
      });
    },
    updateEnabled() {
      const en = this.integrations.pulse_m.enabled;
      this.updateIntegrations({
        integrations: { pulse_m: { enabled: en } }
      }).then(() => {
        window.notify.success(`pulseM ${en ? "enabled" : "disabled"}!`);
      });
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    }
  }
};
</script>
